import { getTrackCircuitsAtLocations, getTrackCircuitsWithIds } from 'src/Providers/OrchestratedTrackCircuit'
import { getDateRange } from 'src/Features/SelectedDatePeriod/predefinedDatePeriods'
import { useAppStateStore } from 'src/Store/appState'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'
import type { AggregatedAssetParams } from 'src/Hooks/NetworkData/useAggregatedAssets'
import { LocationFeatures, useLocationFeature } from 'src/Hooks/useLocationFeatures'

export const useTrackCircuitsWithAlarms = ({
  datePeriod,
  idType,
  ids,
  onlyWithAlarms = false,
  enableAllAlarmTypes = false,
  enabled = true,
}: AggregatedAssetParams) => {
  const lastUpdated = useAppStateStore(state => state.selectedDatePeriod.lastUpdated)
  const fakeSparseResponseData = useLocationFeature(LocationFeatures.FakeSparseResponseData)
  const synthSparseResponseData = useLocationFeature(LocationFeatures.SynthSparseResponseData)

  const query = useQueryWithErrorHandling(
    ['trackCircuitsWithAlarms', { idType, ids, datePeriod, onlyWithAlarms, enableAllAlarmTypes, lastUpdated, enabled }],
    () => {
      if (!datePeriod || !enabled) {
        return []
      }
      const dateRange = getDateRange(datePeriod)
      if (idType === 'baneDataLocationIds') {
        return getTrackCircuitsAtLocations(
          dateRange,
          ids,
          onlyWithAlarms,
          enableAllAlarmTypes,
          fakeSparseResponseData,
          synthSparseResponseData
        )
      }

      return getTrackCircuitsWithIds(
        dateRange,
        ids,
        onlyWithAlarms,
        enableAllAlarmTypes,
        fakeSparseResponseData,
        synthSparseResponseData
      )
    },
    {
      enabled: ids.length > 0,
    },
    'alarms.fetchError'
  )

  return {
    ...query,
    trackCircuitsWithAlarms: query.data,
  }
}
